import type { PropsWithChildren } from 'react'

import { BodySubtext } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const ConstraintContainer: React.FC<
  PropsWithChildren<{ className?: string }>
> = ({ children, className }) => (
  <div className={cn('bg-background w-full', className)}>{children}</div>
)

export const ConstraintLabelContainer: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex flex-col gap-1">{children}</div>

export const ConstraintLabelInner: React.FC<PropsWithChildren> = ({
  children,
}) => <div className="flex items-center gap-2">{children}</div>

export const ConstraintLabelText: React.FC<PropsWithChildren> = ({
  children,
}) => <BodySubtext className="">{children}</BodySubtext>
